import routes from './route';

export default routes;
